<app-dialog-base titleTranslationKey="admin.terms-updates.dialog-title">
    <ng-container content>
        <!-- <app-pending-container lo>

        </app-pending-container> -->
            <form [formGroup]="form" id="myform" (ngSubmit)="submitForm()" autocomplete="off" class="common-form">
            <div class="form-row">
                <app-rich-text-form-field labelT="FIDUCIARY.tasks.task-form.description" formControlName="rawHtml" />
            </div>
        </form>
        <app-loading-spinner-overlay *ngIf="(loadingService.loading$ | async)">
            some
        </app-loading-spinner-overlay>
    </ng-container>
    <ng-container actions>
        <div class="button-group">
            <!-- <app-button-cancel (click)="close()" />
            <app-button-save type="submit" /> -->

            <app-button-cancel color="primary" (click)="close()" />
            <app-button-save formId="myform" [disabled]="form.invalid" />
            <!-- <button mat-flat-button [routerLink]="[]" (click)="closeDialog()" mat-button>{{ 'shared.cancel' | translate |
        uppercase }}</button>
      <button mat-flat-button color="primary" [disabled]="!updateEmployeeForm.valid" (click)="saveDialog($event)"
        mat-button>
        {{ 'shared.save' | translate | uppercase }}
      </button> -->
        </div>
    </ng-container>
</app-dialog-base>